<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <div [innerHTML]="termsOfUse"></div>
  <hr>
    <div [innerHTML]="privacyPolicy" class="mt-5"></div>
    @if (emphasizeUserAction) {
      <div class="warn-color">You must confirm that you have read and agree to the terms</div>
    }
    <div [class]="emphasizeUserAction?'highlight':''" >
      @if (termsOfUse && privacyPolicy) {
        <mat-slide-toggle [(ngModel)]="agreeChecked" class="my-2 primary-toggle" color="primary">
          I have read and agree to the site terms and conditions.
        </mat-slide-toggle>
      }
    </div>
    <br/>
    <div #target>By confirming, I agree to the <a mat-button (click)="onConsumerDisclosureClick()"><u>Consumer Disclosure</u></a>, and to use e-signatures.</div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-row space-between items-center w-100 mt-3 p-2">
      @if (!canConfirm) {
        <button mat-flat-button class="w-49 disabled" color="primary" (click)="target.scrollIntoView({ behavior: 'smooth'})" (click)="onScrollClick()">{{confirmButtonText}}</button>
      }
      @else {
        <button mat-flat-button class="w-49" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
      }
      <button mat-flat-button class="w-49" color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
    </div>
  </mat-dialog-actions>


